const SkeletonField = () => (
    <div
        className="dt-field dt-skeleton"
        style={{ width: '100%' }}
    />
);

export default SkeletonField;
